import { Observable } from "rxjs";
import { Metadata } from "src/app/base/model/data-body-request";
import { TypePersonUpdate } from "../../model/TypePersonUpdate";
import { BaseRepository } from "src/app/data/repositories/base/base-repository";
import { ProcessedDataResponse } from "src/app/base/model/processed-data-response";

export abstract class UpdatePersonRepository extends BaseRepository {
    abstract updatePerson(
        params: {
            personId: number,
            typePersonUpdate: TypePersonUpdate,
            metadata: Metadata,
        }): Observable<ProcessedDataResponse<any>>;
}